import BaseSwitch from './BaseSwitch.vue';

export { BaseSwitch };
